import { FC } from 'react'

import PopUpRow from './pop-up-row'

import { ISafetyCaseHazard } from '../../interfaces'

import s from './map-popups.module.scss'

type SafetyCaseHazardPopUpContentProps = {
  safetyCaseHazard?: ISafetyCaseHazard
  onNavigateToSafetyCase?: (safetyCaseHazard?: ISafetyCaseHazard) => void
}

const SafetyCaseHazardPopUpContent: FC<SafetyCaseHazardPopUpContentProps> = props => {
  const { safetyCaseHazard, onNavigateToSafetyCase } = props

  return (
    <div className={s['safety-case-content']}>
      <PopUpRow label="Name" value={safetyCaseHazard?.name || ''} />

      <PopUpRow label="Risk Level" value={safetyCaseHazard?.selectedRiskMatrixCell?.riskLabel || ''} />

      <PopUpRow label="Location" value={safetyCaseHazard?.location?.name || 'Adhoc'} />

      {onNavigateToSafetyCase && (
        <div className="ml-2 mt-2 d-flex align-items-center">
          <span className="font-weight-bold">Safety Case:</span>

          <button
            className="btn btn-link p-0 ml-2 text-decoration-none"
            onClick={() => onNavigateToSafetyCase(safetyCaseHazard)}
          >
            #{safetyCaseHazard?.safetyCaseId}
          </button>
        </div>
      )}
    </div>
  )
}

export default SafetyCaseHazardPopUpContent
